export function getAssetImage(path: string) {
  return `https://cdn.remedium.md/image/assets${path}`;
}
